class FDFooter extends HTMLElement {
 connectedCallback() {
  this.abort?.abort(); this.abort = new AbortController();
  const options = { signal: this.abort.signal };
  this.query = matchMedia('(min-width:1200px)');
  const update = () => { for (const button of this.querySelectorAll('[data-footer-toggle]')) { const open = this.query.matches; button.setAttribute('aria-expanded', String(open)); button.disabled = open; this.querySelector(`#${button.getAttribute('aria-controls')}`).hidden = !open; button.querySelector('span').textContent = open ? '−' : '+'; } };
  this.query.addEventListener('change', update, options); update();
  this.addEventListener('click', event => {
   const toggle = event.target.closest('[data-footer-toggle]');
   if (toggle) { const open = toggle.getAttribute('aria-expanded') !== 'true'; toggle.setAttribute('aria-expanded', String(open)); this.querySelector(`#${toggle.getAttribute('aria-controls')}`).hidden = !open; toggle.querySelector('span').textContent = open ? '−' : '+'; }
   const locale = event.target.closest('[data-footer-localization]');
   if (locale) document.querySelector('fd-header')?.request('localization', locale);
  }, options);
 }
 disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('fd-footer')) customElements.define('fd-footer', FDFooter);
